<template>
  <div class="business">
    <menuBox :step="3"></menuBox>
    <div class="title-box">
      <div class="title">
        加入我們
      </div>
      <div class="l-title">
        加入SAMORE HK LIMITED，與優秀的設計、開發和投資專業團隊一起，共創未來創新之路！ 釋放你的潛能，共同迎接產業挑戰，共建成功之夢
      </div>
    </div>
    <div class="offer-box">
      <div class="item">
        <div class="item-title">
          設計副總監  <span>30-35k</span>
          <div class="btn" @click="contractUs()">加入我們</div>
        </div>
        <div class="detail">
          <div class="detail-title">
            【職位說明】
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            領導設計團隊： 管理和激勵設計團隊，確保團隊成員充分發揮潛力，並實現卓越的設計工作
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            設計策略： 制定並執行公司的設計策略，與其他部門協調合作，確保設計在整個業務中的策略地位
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            專案管理： 確保專案按時交付，並在預算範圍內保持高品質的設計標準
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            創新領導： 推動公司在設計上的創新，專注於產業趨勢，提供具競爭力的設計解決方案
          </div>
        </div>
        <div class="detail">
          <div class="detail-title">
            【崗位要求】
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            本科或以上學歷，設計或相關領域專業
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            卓越的設計技能及至少8年相關工作經驗
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            領導力和團隊管理經驗
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            對設計和創新有強烈的熱情，並具備策略思維
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            優秀的溝通和協作能力
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          JAVA資深開發工程師  <span>25-30K</span>
          <div class="btn" @click="contractUs()">加入我們</div>
        </div>
        <div class="detail">
          <div class="detail-title">
            【職位說明】
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            系統設計與開發： 參與系統架構的設計與開發，確保系統的高效運作與良好的可維護性
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            程式碼品質和效能優化： 負責編寫高品質的Java程式碼，並進行系統效能最佳化和調優
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            團隊協作： 與團隊合作，參與制定技術方案，並為其他團隊成員提供技術支持
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            問題診斷與解決： 負責系統問題的診斷與解決，確保及時回應與修復。
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            新技術研究： 持續關注並研究新的Java技術趨勢，為系統升級提供技術支持
          </div>
        </div>
        <div class="detail">
          <div class="detail-title">
            【崗位要求】
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            本科以上學歷，電腦科學或相關專業
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            至少5年以上Java開發經驗，熟練Spring框架
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            熟悉資料庫設計與最佳化，具有良好的SQL語言功底
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            具備分散式系統開發經驗，了解微服務架構
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            熟悉常見的開發工具與流程，如Git、Jenkins等
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          演算法工程師  <span>36-48K</span>
          <div class="btn" @click="contractUs()">加入我們</div>
        </div>
        <div class="detail">
          <div class="detail-title">
            【職位說明】
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            演算法設計： 負責設計和開發創新的演算法，解決實際業務和技術挑戰
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            資料分析： 分析和處理大規模資料集，提取有價值的資訊和模式
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            模型開發： 建構和優化機器學習和深度學習模型，解決實際問題
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            效能最佳化： 最佳化演算法和模型的效能，確保在大規模資料下的高效運行
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            技術研究： 追蹤最新的演算法和技術發展，為團隊提供技術支持
          </div>
        </div>
        <div class="detail">
          <div class="detail-title">
            【崗位要求】
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            電腦科學或相關專業的碩士或博士學歷
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            至少3年以上演算法工程師或資料科學家的工作經驗
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            熟練使用常見的機器學習和深度學習框架，如TensorFlow、PyTorch等
          </div>
          <div class="detail-item">
            <img src="../assets/point.png" alt="" />
            在自然語言處理、影像處理等領域有實際專案經驗者優先
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    contractUs(){
      this.$router.push({ path: "contractUs" });
    },
    submit() {
      alert("Success");
    },
  },
};
</script>
<style lang="less" scoped>
.title-box {
  background-color: #41289a;
  width: 100%;
  height: 400px;
  overflow: hidden;
  text-align: center;
  .title {
    font-size: 64px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 120px;
  }
  .l-title {
    font-size: 32px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    padding: 0 360px;
    margin-top: 24px;
  }
}
.offer-box {
  padding: 100px 320px;
  .item {
    width: 1277px;
    min-height: 480px;
    overflow: hidden;
    margin-bottom: 60px;
    box-shadow: 2px 2px 20px 5px rgba(209, 209, 234, 0.3);
    border-top: 5px solid #41289a;
    .item-title {
      margin-left: 32px;
      margin-top: 56px;
      margin-bottom: 39px;
      font-size: 41px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 48px;
      span {
        font-size: 36px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #f55031;
        line-height: 42px;
      }
      .btn {
        width: 160px;
        height: 60px;
        background: #41289a;
        border-radius: 4px;
        text-align: center;
        line-height: 60px;
        font-size: 26px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        float: right;
        margin-right: 32px;
      }
    }
    .detail:nth-child(3){
      margin-left: 100px;
    }
    .detail {
      margin-left: 32px;
      width: 500px;
      float: left;
      .detail-title {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
        margin-bottom: 20px;
      }
      .detail-item {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.6);
        line-height: 23px;
        margin-bottom: 14px;
        img {
          width: 8px;
          height: 8px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
